<template>
  <div class="daohang contentCss">
    您所在的位置：<span
      ><span class="clickSyCss" @click="tizozhaunSYClick">首页</span
      ><span style="color: #000"> / {{ Sydata }}</span></span
    >
  </div>
</template>

<script>
export default {
  props: {
    daohangshuju: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      Sydata: this.daohangshuju
    }
  },
  methods: {
    tizozhaunSYClick () {
      this.$router.push('/home')
      location.reload()
    }
  },
  mounted () {
    let daohangArr = [
      { key: 'product', value: '产品简介' },
      { key: 'xdc', value: '信电查' },
      { key: 'report', value: '商务信用评价' },
      { key: 'monitor', value: '电力大数据' },
      { key: 'cecIndex', value: '电力指数' },
      { key: 'financial', value: '金融服务' },
      { key: 'contact', value: '联系我们' },
    ]
    this.activeMenu = window.location.hash.split("#")[1].split("/")[1]
    daohangArr.forEach(item => {
      if (item.key == this.activeMenu) {
        this.daohangshuju = item.value
      }
    })

  },

}
</script>

<style lang="less" scoped>
.daohang {
  padding-bottom: 10px;
  font-size: 20px;
  color: #00489d;
  border-bottom: 1px solid #005ba3;
}
</style>